import { resolveBrandIcon } from "@soonlist/validators";

import { Globe, Ticket } from "~/components/icons";

const INTERACTIVE_1_HEX = "#5A32FB";

export function EventEnrichmentLinkIcon({
  type,
  url,
  size = 14,
  className,
}: {
  type: string;
  url: string;
  size?: number;
  className?: string;
}) {
  const icon = resolveBrandIcon(type, url);
  if (icon) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className={className}
        aria-hidden="true"
      >
        <path fill={icon.color} d={icon.path} />
      </svg>
    );
  }
  if (type === "ticketing") {
    return (
      <Ticket size={size} color={INTERACTIVE_1_HEX} className={className} />
    );
  }
  return <Globe size={size} color={INTERACTIVE_1_HEX} className={className} />;
}
